import { AlertTriangle } from 'lucide-react';
import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert';

export function DemoModeBanner() {
  return (
    <Alert className="border-ss-warning/30 bg-[hsl(var(--ss-warning-bg))]">
      <AlertTitle className="flex items-center gap-2 text-sm font-semibold">
        <AlertTriangle className="h-4 w-4" />
        Demo Mode - Simulated data
      </AlertTitle>
      <AlertDescription className="text-xs text-muted-foreground">
        Demo Mode - Simulated data. No changes are applied to real customer sites.
      </AlertDescription>
    </Alert>
  );
}
